module.exports = [
  "brokerage",
  "security",
  "applicant-warning-message",
  "applicant-ssn",
  "how-to-get-verified-for-credit-reports",
  "privacy",
  "termsofuse",
  "support",
  "applicants",
  "report-accuracy",
  "applicant-benefits",
  "free-rental-application-pdf",
  "tenant-background-check",
  "tenant-screening",
  "tenant-credit-check",
  "online-rental-application",
  "online-apartment-application",
  "landlord-forms",
  "landlord-tenant-forms",
  "forms-for-landlords",
  "condo.com",
  "fill-your-vacancies"
]



// WEBPACK FOOTER //
// ../lib/freeforms/info_page_slugs.coffee